/* eslint-disable prettier/prettier */
import { Auth } from '@aws-amplify/auth';

const cookieStorage = {
  domain:
    process.env.REACT_APP_NODE_ENV === 'development'
      ? 'localhost'
      : 'listwithclever.com',
  secure: true,
  path: '/',
  expires: 365, // expires in days
  sameSite: 'none',
};
// DEBUGGING COGNITO STAGING
const userPoolId =
  process.env.REACT_APP_NODE_ENV === 'staging'
    ? process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_ID_STAGING
    : process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_ID;
const userPoolWebClientId =
  process.env.REACT_APP_NODE_ENV === 'staging'
    ? process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID_STAGING
    : process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID;
// Local dev only: point Amplify at cognito-local (clever-dev-environment).
// This app uses USER_PASSWORD_AUTH, which sends the raw username/password to
// whatever host `endpoint` resolves to. A stray REACT_APP_COGNITO_ENDPOINT in
// a staging/prod build would therefore ship real credentials to that host, so
// only honor the override in development AND only when it points at localhost.
const resolveLocalCognitoEndpoint = (): string | undefined => {
  const endpoint = process.env.REACT_APP_COGNITO_ENDPOINT;
  if (!endpoint || process.env.REACT_APP_NODE_ENV !== 'development') {
    return undefined;
  }
  try {
    const { hostname } = new URL(endpoint);
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return endpoint;
    }
  } catch {
    // Malformed endpoint — ignore it rather than risk a bad configuration.
  }
  return undefined;
};

const localCognitoEndpoint = resolveLocalCognitoEndpoint();

Auth.configure({
  region: process.env.REACT_APP_AWS_AMPLIFY_REGION,
  userPoolId,
  userPoolWebClientId,
  mandatorySignIn: true,
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  cookieStorage,
  ...(localCognitoEndpoint ? { endpoint: localCognitoEndpoint } : {}),
});
